module.exports = __webpack_public_path__ + "img/feixinjiaju3.d358036b.jpg";